import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { base44 } from "@/api/base44Client";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, BarChart3, Calendar, TrendingUp } from "lucide-react";
import ResourceAllocationBoard from "@/components/resources/ResourceAllocationBoard";
import CapacityDashboard from "@/components/resources/CapacityDashboard";
import WorkloadAnalysis from "@/components/resources/WorkloadAnalysis";
import ResourceForecast from "@/components/resources/ResourceForecast";

export default function ResourceManagement() {
  const [selectedView, setSelectedView] = useState("allocation");

  const { data: users = [] } = useQuery({
    queryKey: ["users"],
    queryFn: () => base44.entities.User.list(),
  });

  const { data: projects = [] } = useQuery({
    queryKey: ["projects"],
    queryFn: () => base44.entities.Project.list(),
  });

  const { data: tasks = [] } = useQuery({
    queryKey: ["tasks"],
    queryFn: () => base44.entities.Task.list(),
  });

  const { data: timeEntries = [] } = useQuery({
    queryKey: ["timeEntries"],
    queryFn: () => base44.entities.TimeEntry.list("-created_date"),
  });

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-slate-900 tracking-tight mb-2">Ressursstyring</h1>
          <p className="text-slate-500">Optimaliser teamallokering og kapasitet</p>
        </div>

        <Tabs value={selectedView} onValueChange={setSelectedView} className="space-y-6">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="allocation" className="flex items-center gap-2">
              <Users className="w-4 h-4" />
              Allokering
            </TabsTrigger>
            <TabsTrigger value="capacity" className="flex items-center gap-2">
              <BarChart3 className="w-4 h-4" />
              Kapasitet
            </TabsTrigger>
            <TabsTrigger value="workload" className="flex items-center gap-2">
              <Calendar className="w-4 h-4" />
              Arbeidsmengde
            </TabsTrigger>
            <TabsTrigger value="forecast" className="flex items-center gap-2">
              <TrendingUp className="w-4 h-4" />
              Prognose
            </TabsTrigger>
          </TabsList>

          <TabsContent value="allocation">
            <ResourceAllocationBoard users={users} projects={projects} tasks={tasks} timeEntries={timeEntries} />
          </TabsContent>

          <TabsContent value="capacity">
            <CapacityDashboard users={users} timeEntries={timeEntries} tasks={tasks} />
          </TabsContent>

          <TabsContent value="workload">
            <WorkloadAnalysis users={users} tasks={tasks} timeEntries={timeEntries} />
          </TabsContent>

          <TabsContent value="forecast">
            <ResourceForecast users={users} projects={projects} tasks={tasks} timeEntries={timeEntries} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}